export const SCREEN_NAME = 'ArtistAudioRecord';
